import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function HeroSection() {
  const { hero } = useSiteSettings();

  return (
    <section id="top" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_6111931c4bb171c4945e4de452dcdcb7_c3bd7905.jpg"
          width={1920}
          height={1080}
          alt="Lush green paddy fields and coconut groves of rural Konaseema glowing in fresh warm sunlight"
          title="Rythugaru Agri Tourism - rural India farm landscape"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/70"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-16">
        <div className="max-w-5xl">
          <div className="flex items-center gap-3 mb-6">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
            <span className="text-xs md:text-sm font-semibold tracking-[0.28em] uppercase text-accent-300">
              {hero.eyebrow}
            </span>
          </div>

          <h1 className="font-heading text-background-50 text-4xl sm:text-5xl md:text-7xl leading-[1.05] font-semibold max-w-3xl">
            {hero.title}
            <span className="block italic text-accent-300">{hero.titleAccent}</span>
          </h1>

          <p className="mt-6 md:mt-8 text-lg md:text-2xl text-background-100 font-medium max-w-2xl">
            {hero.subtitle}
          </p>

          <p className="mt-5 text-sm md:text-base text-background-200 leading-relaxed max-w-2xl">
            {hero.description}
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4 mt-9 max-w-lg sm:max-w-none">
            <a
              href={hero.primaryCta.href}
              className="inline-flex items-center justify-center gap-2 bg-accent-500 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              {hero.primaryCta.label}
              <i className="ri-arrow-right-line"></i>
            </a>
            <Link
              to={hero.secondaryCta.href}
              className="inline-flex items-center justify-center gap-2 bg-background-50/10 backdrop-blur-sm border border-background-50/40 text-background-50 text-sm md:text-base font-semibold px-7 py-4 rounded-md hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              {hero.secondaryCta.label}
              <i className="ri-plant-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-14 md:mt-20 max-w-4xl">
          {hero.stats.map((stat) => (
            <div
              key={stat.label}
              className="border-l-2 border-accent-500/70 pl-4"
            >
              <p className="font-heading text-2xl md:text-4xl text-background-50 font-semibold">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm text-background-200 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#why"
        className="relative mx-auto mb-8 w-11 h-11 hidden md:flex items-center justify-center rounded-full border border-background-50/40 text-background-50 animate-floaty cursor-pointer"
        aria-label="Scroll down"
      >
        <i className="ri-arrow-down-line text-xl"></i>
      </a>
    </section>
  );
}